export default "__VITE_ASSET__Co2Q1$cb__"